import { UserManager, Log } from 'oidc-client';

// eslint-disable-next-line no-unused-vars
import _ from 'lodash';

import {
  OIDC_SETTINGS,
  OIDC_TOKEN_TIMEOUT_BEFORE_SECOND,
  AUTH_VALIDATION_RETRY_COUNT_NUM,
} from './constants';
import moment from 'moment';
import SessionStorageService from '../services/utilities/SessionStorageService';
import LocalStorageService from '../services/utilities/LocalStorageService';
//import Fetch from '../utilities/fetchManager';
import { removeSessionItemsForGTM } from './gtm';
import { datadog } from './datadog';
/**
 * oidc-clientライブラリの操作を隠蔽するためのサービスクラスです
 */

const getUrlParameter = (location, name) => {
  try {
    location = decodeURIComponent(location);
  } catch (e) {
    return '';
  }
  return (
    location.split(`?${name}=`)[1] ||
    location.split(`&${name}=`)[1] ||
    ''
  ).split('&')[0];
};

const getLoginId = () => {
  return getUrlParameter(window.location.href, 'loginId');
};

class AuthProvider {
  constructor() {
    const agencySessionId = this._getAgencySessionId();
    let extraQueryParams = {};
    if (agencySessionId) {
      extraQueryParams.agency_sessionid = agencySessionId;
    }
    const loginId = getLoginId();
    if (!_.isEmpty(loginId)) {
      extraQueryParams.loginid = loginId;
    }
    this.userManager = new UserManager({
      ...OIDC_SETTINGS,
      extraQueryParams,
    });

    this.silentTokenUdatingFlag = false;

    // BLDE_V2-24769
    // this.userManager.events.addAccessTokenExpired(() => {
    //   // console.log('Access token expired...authProvider');
    //   this.silentTokenUdate();
    // });

    // BLDE_V2-24769
    // this.userManager.events.addAccessTokenExpiring(() => {
    //   // console.log('Access token expiring...authProvider');
    //   this.silentTokenUdate();
    // });
  }

  /**
   * ログイン済ユーザーを返します
   * @returns {Promise<User>}
   */
  getLoggedInUser() {
    return this.userManager.getUser();
  }

  /**
   * 認証基盤のログインページへ遷移します
   */
  async redirectLoginPage() {
    return this.userManager.signinRedirect();
  }

  /**
   * 認証基盤からのリダイレクト後、認証されたユーザー情報を保存します
   * @returns {Promise<User | never>}
   */
  saveAuthUserInfo() {
    // console.log('debug', 'authProvider.js saveAuthUserInfo');
    // console.log('debug authProvider.js saveAuthUserInfo');
    return this.userManager
      .signinRedirectCallback()
      .then(user => {
        if (user) {
          const token = user.access_token;
          // console.log(
          //   'debug',
          //   'authProvider.js saveAuthUserInfo signinRedirectCallback then',
          //   'localStorage.setItem',
          //   user,
          //   token
          // );

          SessionStorageService.setToken(token);
          LocalStorageService.setRetryCount(0);
          LocalStorageService.removeItem('is_logout');
          return user;
        } else {
          return null;
        }
      })
      .catch(err => {
        let authValidationRetryCount = LocalStorageService.getRetryCount();
        LocalStorageService.setRetryCount(++authValidationRetryCount);
        if (authValidationRetryCount < AUTH_VALIDATION_RETRY_COUNT_NUM) {
          console.error('authProvider.js saveAuthUserInfo', 'signinRedirect');
          this.userManager.signinRedirect();
          // トップページからの再ログイン処理
        } else {
          LocalStorageService.setRetryCount(0);
          console.error(
            'authProvider.js saveAuthUserInfo',
            `login error catch ${err.toString()}`
          );
        }
      });
  }

  sleepByPromise(msec) {
    return new Promise(resolve => setTimeout(resolve, msec));
  }

  /**
   * トークンのサイレント更新を行う
   */
  async silentTokenUdate() {
    // console.log('authProvider.js silentTokenUdate');
    if (this.silentTokenUdatingFlag === true) {
      // waitFunc で各APIが非同期実行された場合でも
      // トークン更新処理が走った場合は
      // silentTokenUdatingFlag のフラグが更新されるまで
      // 処理を停止するようにした。

      // Waitなしの待機関数
      //  結構うまく動くがIE11がだいぶ遅くなりフリーズする様子
      // const waitFunc = async () => {
      //   while (true) {
      //     if (!_.isNull(this.silentTokenUdatingFlag)) {
      //       return;
      //     }
      //   }
      // };

      // Waitありの待機関数
      const waitFunc = async () => {
        while (true) {
          await this.sleepByPromise(500);
          if (this.silentTokenUdatingFlag === false) {
            return;
          }
        }
      };

      await waitFunc();
      return SessionStorageService.getToken();
    }
    this.silentTokenUdatingFlag = true;
    let token = '';
    await this.userManager
      .signinSilent()
      .then(user => {
        // console.log('authProvider.js silentTokenUdate signinSilent success');

        if (user) {
          token = user.access_token;
          SessionStorageService.setToken(token);
          LocalStorageService.removeItem('is_logout');
        }
      })
      .catch(async data => {
        const errorMessage = data.toString();
        console.error(
          'authProvider.js silentTokenUdate signinSilent catch',
          'ErrorMessage:',
          errorMessage,
          'token:',
          SessionStorageService.getToken()
        );

        if (errorMessage.includes('login_required')) {
          // console.log(
          //   'authProvider.js silentTokenUdate',
          //   '認証クッキー期限切れのためログアウトします',
          //   errorMessage
          // );

          // session切れの時はログアウトする
          await this.logout();
          await this.sleepByPromise(1000); // logout前にAPIが実行されることがあったため少し待つ
        } else if (
          errorMessage.includes('No matching state found in storage')
        ) {
          // console.log(
          //   'authProvider.js silentTokenUdate',
          //   '認証クッキー期限切れのためログアウト中です',
          //   errorMessage
          // );
          await this.redirectLoginPage();
        } else if (errorMessage.includes('Frame window timed out')) {
          // console.log(
          //   'authProvider.js silentTokenUdate',
          //   '認証エラーのためログアウトします',
          //   errorMessage
          // );
          // this.logout();
          await this.redirectLoginPage();
        } else if (errorMessage.includes('Network Error')) {
          console.error(
            'authProvider.js silentTokenUdate',
            'ネットワークエラーです',
            errorMessage
          );
          await this.redirectLoginPage();
        } else {
          throw new Error(
            `authProvider.js silentTokenUdate catch ${data.toString()}`
          );
        }
      })
      .finally(() => {
        this.silentTokenUdatingFlag = false;
      });
    return token;
  }

  /**
   * ログアウトします
   */
  async logout(signoutRedirectArg) {
    // console.log('debug', 'logout');
    SessionStorageService.removeItem('relayPoint');
    SessionStorageService.removeItem('directLink');
    SessionStorageService.removeListCheckedClasses();
    LocalStorageService.removeItem('oidc.default');
    if (SessionStorageService.getToken()) {
      localStorage.clear();

      // oidcクライアント以外の情報を削除
      // selectClearItem()には削除したいキーを明記すれば削除可能
      SessionStorageService.selectClearItem();
    }
    removeSessionItemsForGTM();

    // DataDogのユーザーセッションを削除する
    datadog.clearUser();

    return this.userManager.signoutRedirect(signoutRedirectArg);
  }

  /**
   * 代理ログインのセッションIDをQueryStringから取得します
   */
  _getAgencySessionId() {
    const urlSearchParams = window.URLSearchParams;
    const queryString = window.location.search;

    const queryKey = 'agencySessionId';

    // console.log('debug', '_getAgencySessionId 1', urlSearchParams, queryString);
    if (urlSearchParams) {
      const searchParams = new urlSearchParams(queryString.replace('?', ''));
      // console.log('debug', '_getAgencySessionId 2 searchParams', searchParams);
      return searchParams.get(queryKey) || null;
    } else {
      // for IE11
      const regex = new RegExp(`[?&]${queryKey}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(queryString);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return null;
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
}

/**
 * Jwtの文字列を分割して内部を展開してJSONオブジェクトとして返す
 * @param {string} token
 */
export function parseJwt(token) {
  if (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
  }
  return null;
}

/**
 * トークン内の期限(ExpirationTime)が切れているかどうかを判定する
 * @param {string} token
 * @param {number} offsetSecond 秒数
 *  offsetSecondで指定した秒数の前にトークンが切れていると判断する
 *  実際のトークンは10分後に切れるとして offsetSecond = 330 => 5分30秒と設定すると
 *  ログイン後4分30秒経過すると「トークンが切れそうなので更新が必要」と判断して
 *  needTokenUpdate は true を返すようになる
 */
export function needTokenUpdate(
  token,
  offsetSecond = OIDC_TOKEN_TIMEOUT_BEFORE_SECOND
) {
  const tokenJsonObj = parseJwt(token);
  if (tokenJsonObj === null) {
    return true;
  }

  const nowTime = moment().utc();

  const tokenExpirationTime = moment.unix(tokenJsonObj.exp).utc();
  const tokenNeedUpdateTime = tokenExpirationTime.add(
    -1 * offsetSecond,
    'second'
  );

  const result = nowTime.isAfter(tokenNeedUpdateTime, 'second');

  // console.log(
  //   'auth needTokenUpdate',
  //   result
  //     ? 'The token will expire soon!'
  //     : 'There is still room for token expiration!',
  //   tokenNeedUpdateTime.format(),
  //   nowTime.format(),
  //   tokenExpirationTime.diff(nowTime, 'seconds')
  // );
  return result;
}

export default {
  // eslint-disable-next-line no-undef
  instance: process.env.NODE_ENV === 'test' ? null : new AuthProvider(),
  // jest のテスト動作のときはインスタンスを作成しないようにした
  // なぜかエラーになってしまうための対策。
};



// WEBPACK FOOTER //
// ./src/utilities/authProvider.js